import script from "./ModalUserUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalUserUpdate.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./ModalUserUpdate.vue?vue&type=style&index=1&id=2af3c028&scope=true&lang=css"

const __exports__ = script;

export default __exports__